import React, { useState, useEffect } from 'react';
import { Spin } from 'antd';
import { apis, apiHolder as api } from 'api';
import classnames from 'classnames';
import { useActions, useAppDispatch, useAppSelector } from '@web-common/state/createStore';
import { MailClassifyActions } from '@web-common/state/reducer';
import { Thunks } from '@web-common/state/reducer/mailReducer';
import ClassifyItem from './ClassifyItem';
import listStyle from './classifyList.module.scss';
import MoveList from './MoveList';
import AccountSelect from './AccountSelect';
import SiriusMessage from '@web-common/components/UI/Message/SiriusMessage';
import { getIn18Text } from 'api';
const MailConfApi = api.api.requireLogicalApi(apis.mailConfApiImpl);
const contactApi = api.api.requireLogicalApi(apis.contactApiImpl);
const systemApi = api.api.getSystemApi();
const ClassifyList = ({ editRule, mailBoxs, setListShow, isFirst, _account, optionsList }) => {
    const [dataList, setDataList] = useState([]);
    const [orgList, setOrgList] = useState([]);
    const [visibleDelete, setVisibleDelete] = useState(false);
    const [spinning, setSpinning] = useState(true);
    const [emailContactMap, setEmailContactMap] = useState({});
    const [selectedAccount, setSelectedAccount] = useState([]);
    const { setIsClassifyList } = useActions(MailClassifyActions);
    const { mailFolderId, mailTag } = useAppSelector(state => state.mailClassifyReducer);
    const dispatch = useAppDispatch();
    useEffect(() => {
        const res = [];
        orgList.forEach(item => {
            const { condictions } = item;
            const accounts = condictions === null || condictions === void 0 ? void 0 : condictions.find(i => i.field === 'accounts');
            if (accounts && selectedAccount.every(selectA => accounts.operand.includes(selectA)) && selectedAccount.length) {
                res.push(item);
            }
        });
        setDataList(res);
    }, [selectedAccount, orgList]);
    const getEmailNameMap = (DeepRes) => {
        const contact = DeepRes.reduce((prev, next) => {
            var _a, _b, _c, _d;
            if (!selectedAccount.length) {
                const accounts = (_a = next.condictions) === null || _a === void 0 ? void 0 : _a.find(i => i.field === 'accounts');
            }
            let res = [];
            const condictions = (_b = next.condictions) === null || _b === void 0 ? void 0 : _b.reduce((cpre, cnwxt) => {
                const { operand } = cnwxt;
                return [...cpre, ...operand];
            }, []);
            const actions = (_d = (_c = next.actions) === null || _c === void 0 ? void 0 : _c.find(i => i.type === 'forward')) === null || _d === void 0 ? void 0 : _d.target;
            if (condictions)
                res = res.concat(condictions);
            if (actions)
                res.push(actions);
            return [...res, ...prev];
        }, []);
        const reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
        const emailContact = contact.filter(item => reg.test(item));
        contactApi.doGetContactByItem({ type: 'EMAIL', value: emailContact, _account }).then(item => {
            const itemMap = {};
            item.forEach(i => {
                itemMap[i.contact.accountName] = i.contact.contactName;
            });
            setEmailContactMap(itemMap);
        });
    };
    const getListData = () => {
        var _a, _b;
        if (_account) {
            setSelectedAccount([_account]);
        }
        else {
            const list = ((_b = (_a = systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.prop) === null || _b === void 0 ? void 0 : _b.accountAlias) || [];
            if (list[0])
                setSelectedAccount([list[0]]);
        }
        MailConfApi.getMailClassifyRule(_account).then(res => {
            if (Array.isArray(res)) {
                const folderRelateRules = mailFolderId ? res.filter(item => ((item === null || item === void 0 ? void 0 : item.actions) || []).some(itm => (itm === null || itm === void 0 ? void 0 : itm.type) === 'move' && (itm === null || itm === void 0 ? void 0 : itm.target) === mailFolderId)) : [];
                const tagRelateRules = mailTag
                    ? res.filter(item => ((item === null || item === void 0 ? void 0 : item.actions) || []).some(itm => (itm === null || itm === void 0 ? void 0 : itm.type) === 'tags' && Array.isArray(itm === null || itm === void 0 ? void 0 : itm.value) && itm.value.includes(mailTag)))
                    : [];
                if (isFirst && setListShow) {
                    setListShow(mailFolderId ? folderRelateRules.length > 0 : mailTag ? tagRelateRules.length > 0 : res.length > 0);
                }
                let DeepRes = mailFolderId ? [...folderRelateRules] : [...res];
                DeepRes = mailTag ? [...tagRelateRules] : DeepRes;
                setDataList(DeepRes.slice(0).reverse());
                setOrgList(DeepRes.slice(0).reverse());
                getEmailNameMap(DeepRes.length ? DeepRes : [...res]);
                setSpinning(false);
            }
        });
    };
    useEffect(() => () => {
        setDataList([]);
        setOrgList([]);
    }, []);
    useEffect(() => {
        getListData();
        dispatch(Thunks.requestTaglist({}));
    }, []);
    const deleteClassifyItem = item => {
        if (!item)
            return;
        return new Promise(resolve => {
            MailConfApi.deleteMailClassifyRule([item.id], _account)
                .then(res => {
                if (res === null || res === void 0 ? void 0 : res.success) {
                    getListData();
                    setVisibleDelete(false);
                }
                else {
                    (res === null || res === void 0 ? void 0 : res.title) && SiriusMessage.error({ content: res.title });
                }
                resolve(res);
            })
                .catch(() => {
                SiriusMessage.error({ content: getIn18Text('GUIZEBAOCUNSHIBAI') || '操作失败' });
                resolve({ success: false });
            });
        });
    };
    const getEmptyText = () => {
        if (selectedAccount.length <= 0) {
            return getIn18Text('XUANZESHIYONGZHANG');
        }
        if (mailFolderId) {
            return getIn18Text('GAIWENJIANJIAZANWUFEN');
        }
        if (mailTag) {
            return getIn18Text('GAIBIAOQIANZANWUFENLEI');
        }
        return getIn18Text('GAIZHANGHAOXIAWU');
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(AccountSelect, { selectedAccount: selectedAccount, setSelectedAccount: setSelectedAccount, optionsList: optionsList, _account: _account }),
        dataList.length ? (React.createElement("div", null,
            React.createElement(MoveList, { dataList: dataList, setDataList: setDataList, _account: _account, renderItem: (item, index) => (React.createElement(ClassifyItem, { key: item.id, data: item, emailContactMap: emailContactMap, id: item.id, deleteClassifyItem: () => {
                        deleteClassifyItem(item);
                    }, editRule: editRule, getListData: getListData, mailBoxs: mailBoxs, _account: _account })) }))) : (React.createElement(Spin, { spinning: spinning, wrapperClassName: classnames(listStyle.spinning) },
            React.createElement("div", { className: classnames(listStyle.empty) },
                React.createElement("div", { className: "sirius-empty" }),
                React.createElement("div", { style: { marginTop: 20 } }, getEmptyText()))))));
};
export default ClassifyList;
